import {useContext} from "react";
import {FormContext} from "~/components/forms/FormContext";
import Modal from "~/components/Modal";
import ThemedForm from "~/components/forms/ThemedForm";
import ModalContainer from '~/components/ModalContainer.jsx';

const ThemedModal = ({isOpen, onClose, children, ...props}) => {
    const { form } = useContext(FormContext);

    return (
        <ModalContainer isOpen={isOpen} onClose={onClose} {...props}>
            <ThemedForm styles={form?.settings?.styles}>
                {children}
            </ThemedForm>
        </ModalContainer>
    )
}

export default ThemedModal;
